import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {listUserPoolClients} from "apollo/queries/listUserPoolClients";
import {updateUserPoolClientMutation} from "apollo/mutations/updateUserPoolClient";
import {createUserPoolClientMutation} from "apollo/mutations/createUserPoolClient";
import {deleteUserPoolClientMutation} from "apollo/mutations/deleteUserPoolClient";
import {fetchUserPoolClientsSuccess, updateUserPoolClientSuccess,
createUserPoolClientSuccess, deleteUserPoolClientSuccess} from "../actions/UserPoolClient";
import {fetchError} from "../actions/Common";
import {client} from "apollo/client";

import {
  CREATEUSERPOOLCLIENT,
  UPDATEUSERPOOLCLIENT,
  DELETEUSERPOOLCLIENT,
  FETCHUSERPOOLCLIENTS,
} from "constants/ActionTypes";

const getUserPoolClientsRequest = async () => {
  try {
    let { data, error } = await client.query({
      query: listUserPoolClients,
      variables: {
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createUserPoolClientRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createUserPoolClientMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateUserPoolClientRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: updateUserPoolClientMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteUserPoolClientRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteUserPoolClientMutation,
      variables: {
        clientId: input
      }
    });

    console.log('data', data);

    if (data.deleteUserPoolClient.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Client id not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

function* getUserPoolClientsCall({payload}) {
  console.log('getUserPoolClientsCall', payload);

  try {
    const fetched = yield call(getUserPoolClientsRequest);
    yield put(fetchUserPoolClientsSuccess(fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createUserPoolClientCall({payload}) {

  try {
    const created = yield call(createUserPoolClientRequest, payload);
    yield put(createUserPoolClientSuccess(created));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateUserPoolClientCall({payload}) {
  try {
    const updated = yield call(updateUserPoolClientRequest, payload);
    yield put(updateUserPoolClientSuccess(updated));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteUserPoolClientCall({payload}) {

  try {
    const deleted = yield call(deleteUserPoolClientRequest, payload);
    yield put(deleteUserPoolClientSuccess(deleted));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchUserPoolClients() {
  yield takeEvery(FETCHUSERPOOLCLIENTS, getUserPoolClientsCall);
}

export function* updateUserPoolClient() {
  yield takeEvery(UPDATEUSERPOOLCLIENT, updateUserPoolClientCall);
}

export function* createUserPoolClient() {
  yield takeEvery(CREATEUSERPOOLCLIENT, createUserPoolClientCall);
}

export function* deleteUserPoolClient() {
  yield takeEvery(DELETEUSERPOOLCLIENT, deleteUserPoolClientCall);
}

export default function* rootSaga() {
  yield all([
  fork(updateUserPoolClient),
  fork(createUserPoolClient),
  fork(deleteUserPoolClient),
  fork(fetchUserPoolClients)]);
}
